// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"15":"8d4d3527","270":"172e84a6","384":"96d9816f","538":"41344e7b","896":"3a98a772"}[chunkId] + ".css";
};